import { plainToClass } from "class-transformer";
import { JsonItem, AppUserRedacted, PickListItem, RevamppCenter, ListInformation, RevamppCore } from "../../../../secure/list-management/scripts/list-management.objects";
import { EditController } from "../../../list-management/scripts/list-management.controllers";
import { Section, SectionField } from "../../../list-management/scripts/list-management.form-sections";
import { getDisplayDate } from "../../../../shared/scripts/date-functions";

export class ProjectManagerCorePage {
    coreList: RevamppCore[];

    centerPickList: PickListItem[];
    pickLists: JsonItem[];

    editModalId: string;
    coreEditController: EditController;
    currentListController: any;

    pmCoreContainer: JQuery<HTMLElement>;

    constructor(coreList: any, pickLists: any) {
        $(() => {
            this.coreList = plainToClass(RevamppCore, <RevamppCore[]>coreList);
            this.coreList.sort((x1, x2) => x1.CoreName.localeCompare(x2.CoreName));
            this.pickLists = plainToClass(JsonItem, <JsonItem[]>pickLists);
            this.centerPickList = this.pickLists.find(list => list.Id == "pl-center")?.Json;
            this.pmCoreContainer = $("#pm-core-content");

            this.initialize();
        });
    }

    initialize(): void {
        this.initializeEditController();
        let content = this.generateHtml();
        this.pmCoreContainer.empty().html(content);
    }

    initializeEditController(): void {
        this.currentListController = this;
        this.editModalId = "edit-item-modal";
        this.coreEditController = new EditController("pm-core-edit-controller", "Edit Core", "SaveCores",
            [
                new Section("pm-edit-core-description-section", "Description",
                    [
                        new SectionField("pm-edit-core-public-description", "Public Description", "input-limit-1000", "PublicDescription", true, "", "The core's public description will be displayed on the public-facing page for this Research Center."),
                    ]
                ),
                new Section("pm-edit-core-services-section", "Core Services",
                    [
                        new SectionField("pm-edit-core-services", "Core Services", "multi-dropdown-pl", "CoreServicesIds", false, "pl-core-services"),
                        /*new SectionField("add-core-approved-human-subjects", "Approved Human Subjects", "dropdown-pl", "IsApprovedHumanSubjects", true, "pl-yes-no"),
                        new SectionField("add-core-approved-vertebrate-animals", "Approved Vertebrate Animals", "dropdown-pl", "IsApprovedVertebrateAnimals", true, "pl-yes-no"),
                        new SectionField("add-core-approved-select-agents", "Approved Select Agents", "dropdown-pl", "IsApprovedSelectAgents", true, "pl-yes-no"),*/
                    ]
                ),
                new Section("pm-edit-core-virus-focus-section", "Virus Focus",
                    [
                        new SectionField("pm-edit-core-virus-family-focus", "Virus Family Focus", "multi-dropdown-pl", "VirusFamilyFocusIds", false, "pl-virus-family"),
                        new SectionField("pm-edit-prototype-virus", "Prototype Virus Focus", "pathogen-focus-selection", "PrototypeVirusIds", false, "all-viruses", "", undefined, ["pl-virus-family"]),
                        new SectionField("pm-edit-testcase-virus", "Test Case Virus Focus", "pathogen-focus-selection", "TestCaseVirusIds", false, "all-viruses", "", undefined, ["pl-virus-family"]),
                    ], "", "", false, true
                ),
                new Section("pm-edit-core-vaccine-antibody-approach-section", "Vaccine/Antibody Approach",
                    [
                        new SectionField("pm-edit-core-vaccine-approach", "Vaccine Platform Approach", "multi-dropdown-pl", "VaccineApproachesIds", false, "pl-vaccine"),
                        new SectionField("pm-edit-core-antibody-approach", "Antibody Platform Approach", "multi-dropdown-pl", "AntibodyApproachesIds", false, "pl-antibody"),
                    ]
                ),
            ]
            , "edit-item-modal", "CoreName"
        )
    }

    closeAllModals() {
        $(".modal").modal('hide');
    }

    generateHtml(): string {
        let html = ``;
        let centerIds: number[] = [];
        this.coreList.forEach(core => {
            if (!centerIds.includes(core.CenterId)) {
                centerIds.push(core.CenterId);
            }
        });

        centerIds.sort((x1, x2) => {
            let foundCenter1 = this.centerPickList.find(center => center.Id == x1);
            let foundCenter2 = this.centerPickList.find(center => center.Id == x2);
            return foundCenter1?.Value.localeCompare(foundCenter2?.Value);
        });

        centerIds.forEach(centerId => {
            let foundCenter = this.centerPickList.find(center => center.Id == centerId);
            if (foundCenter) {
                let centerContent = "";
                let associatedCores = this.coreList.filter(core => core.CenterId == centerId);
                associatedCores.forEach(core => {
                    let coreContent = this.generateHtmlForCore(core);
                    centerContent += coreContent;
                });
                html += `
                    <div class="pm-accordion-title">${foundCenter.Value}</div>
                    <div class="accordion mb-4 pt-2" id="pm-cores-accordion-${centerId}">
                        ${centerContent}
                    </div>
                `
            }
        })

        return html;
    }

    generateHtmlForCore(core: RevamppCore): string {
        let centerAbbreviation = ""
        let foundCenter = this.centerPickList.find(center => center.Id == core.CenterId);
        if (foundCenter) {
            centerAbbreviation = foundCenter.Value;
        }

        let content = `
            <div class="card accordion-item" id="core-${core.Id}">
                <div class="accordion-header collapsed" data-toggle="collapse" data-target="#collapse-${core.Id}">
                    <span class="accordion-title">${core.CoreName}</span>
                    <span class="arrow">▼</span>
                </div>
                <div class="collapse" id="collapse-${core.Id}" data-parent="#pm-cores-accordion-${core.CenterId}">
                    <div class="card-body">
                        <div class="col-12 border-bottom px-0 pb-3">
                            <div class="row justify-content-between">
                                <div class="col-auto">
                                    <div class="pm-inner-title">${centerAbbreviation} | ${core.CoreName}</div>
                                    <div class="pm-innter-secondary-title">${core.OrgName}</div>
                                </div>
                                <div class="col-auto">
                                    <div class="text-right font-size15"><b>Last Updated: </b>${getDisplayDate(core.LastUpdated)}</div>
                                </div>
                            </div>            
                        </div>
                        <div class="col-12 border-bottom px-0 py-3">
                            <div class="row justify-content-between mb-3">
                                <div class="col-auto">
                                    <div class="pm-section-label">Public Description</div>
                                </div>
                                <div class="col-auto">
                                    <div class="greenbtn inner-card-btn" onclick="page.openEditModal('pm-edit-core-description-section', ${core.Id})">Edit Description</div>
                                </div>
                            </div>
                            <div>
                                <p>${core.PublicDescription}</p>
                            </div>
                        </div>
                        <div class="col-12 border-bottom px-0 py-3">
                            <div class="row justify-content-between mb-2">
                                <div class="col-auto">
                                    <div class="pm-section-label">Core Services</div>
                                </div>
                                <div class="col-auto">
                                    <div class="greenbtn inner-card-btn" onclick="page.openEditModal('pm-edit-core-services-section', ${core.Id})">Edit Core Services</div>
                                </div>
                            </div>
                            <div>
                                <div class="pill-list-container mb-3">
                                    <div class="row">
                                        ${this.generatePillContent(core.CoreServicesIds, "pl-core-services", "dark-blue")}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 border-bottom px-0 py-3">
                            <div class="row justify-content-between mb-3">
                                <div class="col-auto">
                                    <div class="pm-section-label">Virus Focus</div>
                                </div>
                                <div class="col-auto">
                                    <div class="greenbtn inner-card-btn" onclick="page.openEditModal('pm-edit-core-virus-focus-section', ${core.Id})">Edit Virus Focus</div>
                                </div>
                            </div>
                            <div class="pill-list-container mb-3">
                                <div class="pill-list-label">
                                    <span class="pill-list-icon light-blue"></span>
                                    Virus Family Focus
                                </div>
                                <div class="row">
                                    ${this.generatePillContent(core.VirusFamilyFocusIds, "pl-virus-family", "light-blue")}
                                </div>
                            </div>
                            <div class="pill-list-container mb-3">
                                <div class="pill-list-label">
                                    <span class="pill-list-icon light-green"></span>
                                    Prototype Virus Focus
                                </div>
                                <div class="row">
                                    ${this.generatePillContent(core.PrototypeVirusIds, "pl-virus", "light-green")}
                                </div>
                            </div>
                            <div class="pill-list-container mb-3">
                                <div class="pill-list-label">
                                    <span class="pill-list-icon yellow"></span>
                                    Test Case Virus Focus
                                </div>
                                <div class="row">
                                    ${this.generatePillContent(core.TestCaseVirusIds, "pl-virus", "yellow")}
                                </div>
                            </div>
                        </div>
                        <div class="col-12 border-bottom px-0 py-3">
                            <div class="row justify-content-between mb-3">
                                <div class="col-auto">
                                    <div class="pm-section-label">Vaccine & Antibody Approach</div>
                                </div>
                                <div class="col-auto">
                                    <div class="greenbtn inner-card-btn" onclick="page.openEditModal('pm-edit-core-vaccine-antibody-approach-section', ${core.Id})">Edit Approach</div>
                                </div>
                            </div>
                            <div class="pill-list-container mb-3">
                                <div class="pill-list-label">
                                    <span class="pill-list-icon light-blue"></span>
                                    Vaccine Approaches
                                </div>
                                <div class="row">
                                    ${this.generatePillContent(core.VaccineApproachesIds, "pl-vaccine", "light-blue")}
                                </div>
                            </div>
                            <div class="pill-list-container mb-3">
                                <div class="pill-list-label">
                                    <span class="pill-list-icon light-green"></span>
                                    Antibody Approaches
                                </div>
                                <div class="row">
                                    ${this.generatePillContent(core.AntibodyApproachesIds, "pl-antibody", "light-green")}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `
        return content;
    }

    generatePillContent(idString: string, pickList: string, color: string): string {
        if (idString == null || idString == "") {
            return "<div class='error-msg col-auto'>--Not Specified--</div>"
        }
        let foundPickList: PickListItem[] = this.pickLists.find(list => list.Id == pickList)?.Json;
        if (!foundPickList) {
            return "<div class='error-msg col-auto'>--No Pick List Found--</div>"
        }

        let idArr: string[] = idString.split("|");
        let valArr: string[] = [];
        let returnContent: string = ``;
        idArr.forEach(id => {
            let foundItem = foundPickList.find(item => item.Id.toString() == id);
            if (foundItem) {
                valArr.push(foundItem.Value);
            }
        });
        valArr.sort();
        valArr.forEach(val => {
            returnContent += `
                <div class="col-auto pr-0 mb-2">
                    <div class="pill-list-item ${color}">${val}</div>
                </div>`
        })

        if (returnContent == "") {
            return "<div class='error-msg col-auto'>--Not Specified--</div>";
        }
        return returnContent;
    }

    updateCoreDisplay(cores: RevamppCore[]) {
        cores.forEach(core => {
            let previousCoreIndex = this.coreList.findIndex(prevCore => prevCore.Id == core.Id);
            if (previousCoreIndex >= 0) {
                this.coreList.splice(previousCoreIndex, 1, core);
            }
            let newContent: string = this.generateHtmlForCore(core);
            $(`#core-${core.Id}`).replaceWith(newContent);
            $(`#core-${core.Id}`).find(".accordion-header").trigger('click');
        })
    }

    openEditModal(sectionId: string, targetId: number) {
        this.coreEditController.showLoading(false);

        let foundCore = this.coreList.find(core => core.Id == targetId);
        if (foundCore) {
            this.coreEditController.initialize(this.pickLists, [foundCore], sectionId);
            $(`#${this.editModalId}`).modal('show');
        }
    }

    async saveEditModal() {
        // if it isn't valid, don't save
        let isValid = this.coreEditController.validate();
        if (!isValid) {
            return;
        }
        else {
            // show saving on edit modal
            this.coreEditController.showLoading(true);

            // saves changes to DB (returns updated items)
            let result: any[] = await this.coreEditController.save();

            // reinitialze
            this.updateCoreDisplay(result);

            // Show Saved
            this.coreEditController.showSaved(true);


            // hide loading/close modal
            setTimeout(() => {
                $(`#${this.editModalId}`).modal('hide');

                // Don't hide information until after modal finishes hiding
                setTimeout(() => {
                    this.coreEditController.showLoading(false);
                    this.coreEditController.showSaved(false);
                }, 1000)
            }, 1000)
        }
    }
}